// extracted by mini-css-extract-plugin
module.exports = {"melodyCardCategory":"Pf","categoryName":"Qf","categoryImage":"Rf","categoryContent":"Sf","bottomAligned":"Tf"};